<template>
  <div class="form" style="margin-top: 100px">
    <v-card class="grey lighten-5">
      <v-container>
        <h1 align="center">Daftar Sampel BP</h1><br>

        <v-form ref="formsimpansampel" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="3">
              <v-select
                :items="lookupnegeri"
                v-model="NEGERI"
                label="Negeri"
                item-text="negeri"
                item-value="id"
                @change="tukarsampel"
                outlined
                dense
                :rules="requiredRule"
              ></v-select>
            </v-col>
          </v-row>

          <v-row v-show="bahagiantambahsampel">
            <v-card-title>
              {{ $t("tambahsampel") }}
            </v-card-title>
          </v-row>
          <v-row v-show="bahagiantambahsampel">
            <v-col cols="1" sm="1">
               <v-text-field
                  outlined
                  dense
                  v-model="daftarDP"
                  v-bind:label="$t('dp')"
                  type="number"
                  :rules="required2digit"
                  @keypress="limitDigits2"
                  :min="0"
                ></v-text-field>
            </v-col>
             
            <v-col cols="1" sm="1">
               <v-text-field
                  outlined
                  dense
                  v-model="daftarDB"
                  v-bind:label="$t('db')"
                  type="number"
                  :min="0"
                  :rules="required3digit"
                  @keypress="limitDigits3"
                ></v-text-field>
            </v-col>

            <v-col cols="1" sm="2">
               <v-text-field
                  outlined
                  dense
                  v-model="daftarBP"
                  v-bind:label="$t('bp')"
                 :rules=" required6digit"
                 :maxlength="6"
                ></v-text-field>
            </v-col>

            <v-col cols="1" sm="1">
               <v-select
               v-model="daftarST"
              :items="[1,2,3,4]"
              :rules="requiredRule"
               v-bind:label="$t('st')"
              outlined
              dense
              ></v-select>
            </v-col>

            <v-col cols="1" sm="1">
               <v-select
                  outlined
                  dense
                  v-model="daftarTKU"
                  :items="[1,2]"
                  v-bind:label="$t('tku')"
                 :rules="requiredRule"
                ></v-select>
            </v-col>

            <v-col cols="2" sm="2">
               <v-select
                  outlined
                  dense
                  v-model="daftarSampel"
                  v-bind:label="$t('sample')"
                  :items="[1,2]"
                  :rules="requiredRule"
                ></v-select>
            </v-col>
            <v-col>
              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="simpansampel"
              >
                {{ $t("tambah") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

         <!-- Table Data -->
        <v-card>
            <v-card-title>
              {{ $t("senaraisampel") }}
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataSampel"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
            ></v-data-table>
          </v-card>

            <!-- Row Click Dialog -->
      <v-dialog v-model="rowClick" max-width="500" persistent>
        <v-form ref="formUpdate" v-model="dialogValid" lazy-validation>
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("datasampel") }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              {{ $t("negeri") }}
              <v-text-field
                outlined
                dense
                :value="selectedNegeriName"
                disabled
                readonly
              ></v-text-field>
            </v-col>
            <v-col>
              {{ $t("dp") }}
              <v-text-field
                outlined
                dense
                v-model="paparsampel.daftarDP"
                @keypress="limitDigits2"
                :rules=" required2digits"
              ></v-text-field>
            </v-col></v-row>
            <v-row>
            <v-col>
              {{ $t("db") }}
              <v-text-field
                outlined
                dense
                v-model="paparsampel.daftarDB"
                @keypress="limitDigits3"
                :rules=" required3digits"
              ></v-text-field>
            </v-col>      
            <v-col>
              {{ $t("bp") }}
              <v-text-field
                outlined
                dense
                v-model="paparsampel.daftarBP"
               :maxlength="6"
               :rules=" required6digits"
              ></v-text-field>
            </v-col></v-row>
            <v-row>
            <v-col>
              {{ $t("st") }}
              <v-select
                outlined
                dense
                v-model="paparsampel.daftarST"
                :items="[1,2,3,4]"
                :rules="requiredRule"
              ></v-select>
            </v-col>
            <v-col>
              {{ $t("tku") }}
              <v-select
                outlined
                dense
                v-model="paparsampel.daftarTKU"
                :items="[1,2]"
                :rules="requiredRule"
              ></v-select>
            </v-col>
            </v-row>
            <v-row>
            <v-col>
              {{ $t("sample") }}
              <v-select
                outlined
                dense
                v-model="paparsampel.daftarSampel"
                :items="[1,2]"
                :rules="requiredRule"
              ></v-select>
            </v-col>
          
            <v-col>
              {{ $t("hidframe") }}
              <v-text-field
                outlined
                dense
                v-model="paparsampel.HID"
                disabled
                readonly
              ></v-text-field>
            </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="warning" @click="rowClick = false"> {{ $t("batal")}} </v-btn>

          <v-btn color="primary" @click="Pengesahankemaskini = true" > {{ $t("kemaskini")}} </v-btn>

          <v-btn color="error" @click="Pengesahanpadam = true" >{{ $t("padam")}} </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    </v-dialog>
    

    <!-- Pengesahan Kemaskini Dialog -->

 <v-row justify="center">
    <v-dialog
      v-model="Pengesahankemaskini"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dikemaskini!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk mengemaskini pengisian?")}}<br><br>
         <strong>{{$t(" HID: "+this.HID)}}</strong> 
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="Pengesahankemaskini= false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="updatesampel(paparsampel)"
          >
            {{$t('kemaskini')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row> 

   <!-- Pengesahan Padam Dialog -->

 <v-row justify="center">
    <v-dialog
      v-model="Pengesahanpadam"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <strong>{{$t(" HID: "+this.HID)}}</strong> 
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="Pengesahanpadam= false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padam(paparsampel.HID)"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row> 



        <!-- Success Dialog -->
        <v-dialog v-model="successDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">Berjaya!!</v-card-title>
            <v-card-text>{{ successMessage }}</v-card-text>
            <v-card-actions>
              <v-btn color="green" text @click="closeDialogs">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Error Dialog -->
        <v-dialog v-model="errorDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">Gagal!!</v-card-title>
            <v-card-text>{{ errMessage }}</v-card-text>
            <v-card-actions>
              <v-btn color="red" text @click="closeDialogs">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import axios from "../../plugins/axios";

export default {
  data() {
    return {
      successDialog: false,
      errorDialog: false,
      successMessage: 'Data Disimpan!',
      errMessage: 'Sila semak pengisian!',
      lookupnegeri: [],
      NEGERI: null,
      valid: false,
      dialogValid: false,
      search: "",
      dataSampel: [],
      bahagiantambahsampel: false,
      daftarDP: "",
      daftarDB: "",
      daftarBP: "",
      daftarST: "",
      daftarTKU: "",
      daftarSampel: "",
      HID:"",
      paparsampel:[],
      rowClick: false,
      Pengesahankemaskini: false,
      Pengesahanpadam: false,

     requiredRule: [
  v => !!v || 'Perlu di isi',
],
    
   required2digit: [
      v => !!v || 'Perlu di isi',
      v => /^\d{2}$/.test(v) || 'Mesti 2 digit nombor'
    ],

  required3digit: [
      v => !!v || 'Perlu di isi',
      v => /^\d{3}$/.test(v) || 'Mesti 3 digit nombor'
    ],

     required6digit: [
      v => !!v || 'Perlu di isi',
      v => /^\d{6}$/.test(v) || 'Mesti 6 digit nombor'
    ],

    required2digits: [
      v => /^\d{2}$/.test(v) || 'Mesti 2 digit nombor'
    ],

  required3digits: [
      v => /^\d{3}$/.test(v) || 'Mesti 3 digit nombor'
    ],

     required6digits: [
      v => /^\d{6}$/.test(v) || 'Mesti 6 digit nombor'
    ],

      headers: [
        { text: "Bil.", value: "no", sortable: false },
        { text: 'Negeri', value: "NEGERI" },
        { text: 'Daerah Pentadbiran', value: "daftarDP" },
        { text: 'Daerah Banci', value: "daftarDB" },
        { text: 'Blok Perhitungan', value: "daftarBP" },
        { text: 'Strata', value: "daftarST" },
        { text: 'TK Ulang', value: "daftarTKU" },
        { text: 'Sample', value: "daftarSampel" },
        { text: 'HID Frame', value: "HID" },
      ],
    };
  },
  computed: {
    selectedNegeriName() {
      const negeriItem = this.lookupnegeri.find(item => item.id === this.paparsampel.NEGERI);
      return negeriItem ? negeriItem.negeri : ''; // 'negeri' is the text field from your database
    }
  },
  mounted() {
    this.fetchLookupNegeri();
  },

  methods: {
    limitDigits2(event) {
        const value = event.target.value;
        if (value.length >= 2) {
            event.preventDefault();
        }
      },

      limitDigits3(event) {
        const value = event.target.value;
        if (value.length >= 3) {
            event.preventDefault();
        }
      },

    async fetchLookupNegeri() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/HID/lookup`);
        this.lookupnegeri = response.data.lookupnegeri || [];
        console.log("Fetched negeri:", this.lookupnegeri); 
      } catch (error) {
        console.error("Error fetching negeri:", error);
      }
    },

    async simpansampel() {
  if (this.$refs.formsimpansampel.validate()) {
    try {
      // Ensure NEGERI is selected and all required fields are filled
      if (!this.NEGERI) {
        this.errMessage = "NEGERI perlu dipilih!";
        this.errorDialog = true;
        return;
      }

      // Generate HID based on the current values
      const generatedHID = this.NEGERI + this.daftarDP + this.daftarDB + this.daftarBP + this.daftarST;

      // Check if HID already exists
      const checkResponse = await axios.get(`${process.env.VUE_APP_API_URL}/HID/checkHID`, {
        params: { HID: generatedHID, NEGERI: this.NEGERI }
      });

      if (checkResponse.data.exists) {
        this.errMessage = "HID ini sudah wujud!";
        this.errorDialog = true;
        return; 
      }

      const res = await axios.post(`${process.env.VUE_APP_API_URL}/HID/insertBP`, {
        NEGERI: this.NEGERI,
        daftarDP: this.daftarDP,
        daftarDB: this.daftarDB,
        daftarBP: this.daftarBP,
        daftarST: this.daftarST,
        daftarTKU: this.daftarTKU,
        daftarSampel: this.daftarSampel,
        HID: generatedHID // Use the generated HID here
      });

      this.successDialog = true;
      this.errorDialog = false;
      this.reset();
      this.dataSampel = [];
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.successDialog = false;
      }, 2000);

    } catch (error) {
      console.error("Error saving data:", error.response ? error.response.data : error.message);
      this.errMessage = "Error: " + (error.response ? error.response.data.message : error.message);
      this.errorDialog = true;
    }
  } else {
    console.log("Form validation failed.");
    this.errorDialog = true;
    this.successDialog = false;
    window.scrollTo(0, 0);
  }
},

  closeDialogs() {
    if (this.successDialog) {
      this.successDialog = false; 
    } else {
      this.errorDialog = false; 
    }
  },

  reset() {
    this.$refs.formsimpansampel.reset(); 
  },

  async tukarsampel(selectedNegeri) {
  this.bahagiantambahsampel = true;
  this.NEGERI = selectedNegeri; 
  console.log("Selected NEGERI:", this.NEGERI);
  await this.sampelBP(); 
},
async sampelBP() {
  if (!this.NEGERI) {
    this.errMessage = "NEGERI parameter is required";
    this.errorDialog = true;
    return; 
  }

  try {
    const res = await axios.get(`${process.env.VUE_APP_API_URL}/HID/sampelBP?NEGERI=${this.NEGERI}`);
    console.log("Sampel response:", res.data);

    if (res && res.data && Array.isArray(res.data.data)) {
      const sampel = res.data.data.map((element, index) => ({
        no: index + 1,
        NEGERI: element.NG,
        daftarDP: element.DP,
        daftarDB: element.DB,
        daftarBP: element.BP,
        daftarST: element.ST,
        daftarTKU: element.TK_Ulang,
        daftarSampel: element.Sample,
        HID: element.HID_Frame,
      }));
      this.dataSampel = sampel;
    } else {
      console.error("Unexpected response structure:", res);
      this.errMessage = "Unexpected response structure";
      this.errorDialog = true;
    }
  } catch (error) {
    console.error("Error fetching sampel:", error);
    this.errMessage = "Error: " + (error.response ? error.response.data.message : error.message);
    this.errorDialog = true;
  }
},
async handleClick(row) {
      this.rowClick = true;
      this.paparsampel = { ...row,
                        daftarSampel: Number(row.daftarSampel),
                        daftarST: Number(row.daftarST),
                        daftarTKU: Number(row.daftarTKU)}; // Pastikan ini number supaya match dengan v-select
      this.HID = row.HID;
      this.Pengesahankemaskini = false;
      this.Pengesahanpadam = false;
    },

    async updatesampel() {
      if (this.$refs.formUpdate.validate()) {
  try {
    const originalHID = this.paparsampel.HID;

    // Generate new HID based on current values
    const newHID = this.paparsampel.NEGERI + this.paparsampel.daftarDP + this.paparsampel.daftarDB + this.paparsampel.daftarBP + this.paparsampel.daftarST;

    // If new HID is the same as original, skip the existence check
    if (newHID === originalHID) {
      // Proceed to update with the original HID
      await axios.post(`${process.env.VUE_APP_API_URL}/HID/updatesampel`, {
        NEGERI: this.paparsampel.NEGERI,
        daftarDP: this.paparsampel.daftarDP,
        daftarDB: this.paparsampel.daftarDB,
        daftarBP: this.paparsampel.daftarBP,
        daftarST: this.paparsampel.daftarST,
        daftarTKU: this.paparsampel.daftarTKU,
        daftarSampel: this.paparsampel.daftarSampel,
        HID: originalHID, 
      });
    } else {
     // Check if the new HID already exists
     const checkResponse = await axios.get(`${process.env.VUE_APP_API_URL}/HID/checkHID`, {
        params: { HID: newHID, NEGERI: this.paparsampel.NEGERI }
      });

      if (checkResponse.data.exists) {
        this.errMessage = "HID sudah wujud dengan data yang sama!";
        this.errorDialog = true;
        return; 
      }

      // Proceed to update with the new HID
      await axios.post(`${process.env.VUE_APP_API_URL}/HID/updatesampel`, {
        NEGERI: this.paparsampel.NEGERI,
        daftarDP: this.paparsampel.daftarDP,
        daftarDB: this.paparsampel.daftarDB,
        daftarBP: this.paparsampel.daftarBP,
        daftarST: this.paparsampel.daftarST,
        daftarTKU: this.paparsampel.daftarTKU,
        daftarSampel: this.paparsampel.daftarSampel,
        HID:  originalHID, // Use the new HID for the update
      });
    }


    // If the update is successful, now update the local data with the new HID
    const index = this.dataSampel.findIndex(item => item.HID === originalHID);
    if (index !== -1) {
      this.dataSampel.splice(index, 1, { ...this.paparsampel, HID: newHID }); // Update with new data
    }

    this.successMessage = 'Data DiKemaskini!';
    this.successDialog = true; 
    this.rowClick = false;
    this.Pengesahankemaskini = false;

    setTimeout(() => {
      this.successDialog = false;
    }, 2000);
    window.scrollTo(0, 0);
    
  } catch (error) {
    console.error("Error updating sample:", error.response ? error.response.data : error.message);
    this.errMessage = 'Kemaskini : ' + (error.response ? error.response.data.message : error.message);
    this.errorDialog = true;
  }
 
}
    },

async padam(HID) {
  try {
    const res = await axios.post(`${process.env.VUE_APP_API_URL}/HID/deletesampel`, {
      HID: HID  
    });

    this.successMessage = 'Data Dipadam!';
    this.successDialog = true;
    this.dataSampel = this.dataSampel.filter(item => item.HID !== HID);
    this.rowClick = false; 
    this.Pengesahanpadam = false;
    setTimeout(() => {
      this.successDialog = false;
    }, 2000);

    window.scrollTo(0, 0);
  } catch (error) {
    this.errorDialog = true;
    setTimeout(() => {
      this.errorDialog = false;
    }, 2000);
    this.errMessage = 'Padam : ' + error;
  }  
},
  },
};
</script>
<style scoped>
</style>